import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import DataArrayIcon from "@mui/icons-material/DataArray";
import ComputerIcon from "@mui/icons-material/Computer";
import StorageIcon from "@mui/icons-material/Storage";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import SettingsSystemDaydreamIcon from "@mui/icons-material/SettingsSystemDaydream";
import CalculateIcon from "@mui/icons-material/Calculate";
import CodeIcon from "@mui/icons-material/Code";

export const NavbarData = [
  {
    title: "Home",
    icon: <HomeIcon />,
    link: "/home",
  },
  {
    title: "DSA",
    icon: <DataArrayIcon />,
    link: "/dashboard/DSA",
  },
  {
    title: "Python",
    icon: <CodeIcon />,
    link: "/dashboard/PYTHON",
  },
  {
    title: "Operating Systems",
    icon: <SettingsSystemDaydreamIcon />,
    link: "/dashboard/OS",
  },
  {
    title: "Computer Networks",
    icon: <ComputerIcon />,
    link: "/dashboard/CN",
  },
  {
    title: "DBMS",
    icon: <StorageIcon />,
    link: "/dashboard/DBMS",
  },
  {
    title: "Object Oriented Programming",
    icon: <AutoStoriesIcon />,
    link: "/dashboard/OOPS",
  },
  {
    title: "Aptitude",
    icon: <CalculateIcon />,
    link: "/dashboard/APTITUDE",
  },
];
